import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

export interface CartItemRequest {
  product_id: number;
  quantity: number;
  size?: string;
  // task-191: cc_option_items ids; the server validates and prices them.
  selected_cc_option_ids?: number[];
}

export interface CartResponse {
  cart_id: number;
  user_id?: number;
  session_id: string;
  items: Array<{
    cart_item_id: number;
    product_id: number;
    quantity: number;
    size?: string;
    price: number;
  }>;
  total: number;
  created_at: string;
  updated_at: string;
}

export const cartAPI = {
  // Get current cart
  getCart: async (sessionId?: string): Promise<CartResponse> => {
    const response = await axios.get(`${API_BASE}/cart`, {
      params: sessionId ? { session_id: sessionId } : undefined
    });
    return response.data;
  },

  // Add item to cart
  addItem: async (item: CartItemRequest, sessionId?: string): Promise<CartResponse> => {
    const response = await axios.post(
      `${API_BASE}/cart/items`,
      item,
      {
        params: sessionId ? { session_id: sessionId } : undefined
      }
    );
    return response.data;
  },

  // Update item quantity
  updateItem: async (
    cartItemId: number,
    quantity: number,
    sessionId?: string
  ): Promise<CartResponse> => {
    const response = await axios.put(
      `${API_BASE}/cart/items/${cartItemId}`,
      { quantity },
      {
        params: sessionId ? { session_id: sessionId } : undefined
      }
    );
    return response.data;
  },

  // Remove item from cart
  removeItem: async (cartItemId: number, sessionId?: string): Promise<CartResponse> => {
    const response = await axios.delete(
      `${API_BASE}/cart/items/${cartItemId}`,
      {
        params: sessionId ? { session_id: sessionId } : undefined
      }
    );
    return response.data;
  },

  // Clear cart
  clearCart: async (sessionId?: string): Promise<void> => {
    await axios.delete(`${API_BASE}/cart`, {
      params: sessionId ? { session_id: sessionId } : undefined
    });
  },
};